import { useBoolean } from "@/ui-kit";
import type { IInspectorLicense } from "@/types/users-inspectors";
import { useCallback, useState } from "react";
import EditModal from "./EditModal";
import { LicenseDetailsCard } from "@/components/profile-cards";

type IProps = {
  userId: number;
  license: IInspectorLicense;
};

export const LicenseDetails = ({ userId, license }: IProps) => {
  const [values, setValues] = useState<IInspectorLicense>(license);

  const updateValues = useCallback((v: IInspectorLicense) => {
    setValues(v);
  }, []);

  const {
    value: showEditUserModal,
    setTrue: openEditUserModal,
    setFalse: dismissEditUserModal,
  } = useBoolean(false);

  return (
    <>
      <LicenseDetailsCard license={values} onEdit={openEditUserModal} />
      {showEditUserModal && (
        <EditModal
          userId={userId}
          license={values}
          onSave={updateValues}
          onDismiss={dismissEditUserModal}
        />
      )}
    </>
  );
};
